<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                Dealers
              </div>
              <span #dealers class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                {{dealer.nome}}
                <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
              </span>
              <div class="botao">
                <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                  <em class="fa fa-plus"></em>
                </button>
              </div>
              <div class="clear"></div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  Data Inicial
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [maxDate]="maxDate" [yearNavigator]="true"
                  [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataInicial()"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <div class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  Data Final
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [maxDate]="maxDate" [yearNavigator]="true"
                  [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataFinal()"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <button pButton type="button" class="p-button-sm p-button-primary mt-3 mr-2" (click)="filtroAPI()">
                  Filtrar
                  <i class="pi pi-search ml-1"></i>
                </button>
                <button pButton type="button" class="p-button-sm p-button-secondary mt-3 mr-2" icon="pi pi-filter-slash"
                  iconPos="right" (click)="limparFiltros()" pTooltip="Limpar Filtros">
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <app-loading [exibir]="carregando"></app-loading>
    <div *ngIf="!carregando">

      <div *ngIf="registros?.length <= 0" class="sem-registros text-muted mt-2">
        Nenhum registro para exibir
      </div>
      <p-table #dt id="principal" *ngIf="registros?.length > 0" [columns]="columnsSynthetic" [value]="registros"
        class="style" styleClass="p-datatable-striped p-datatable-sm mt-2" [rowHover]="true" [autoLayout]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columnsSynthetic">
              <th class="text-center" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-registros let-columns="columnsSynthetic" let-rowIndex="rowIndex">
          <tr>
            <ng-container *ngFor="let col of columnsSynthetic">
              <td *ngIf="col.field != 'quantidadeBloqueados'" class="text-center">
                {{ registros[col.field] }}
              </td>
              <td *ngIf="col.field == 'quantidadeBloqueados'" class="text-center">
                <a class="link" (click)="getDealerCode(rowIndex)">
                  {{ registros[col.field] }}
                </a>
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="registrosAnalitico?.length > 0" class="mt-3">
      <hr>
      <h5 class="my-3">
        Detalhamento de Operações Bloqueadas: 
        <span class="dealer-info">{{ dealerCodeSelecionado }}</span> - 
        <span class="dealer-info">{{ dealerNameSelecionado }}</span>
      </h5>
      <p-table #dt id="target" [columns]="columnsAnalytical" [value]="registrosAnalitico" class="style"
        styleClass="p-datatable-striped p-datatable-sm mt-4" [rowHover]="true" [autoLayout]="true"
        [paginator]="registrosAnalitico.length > 10" [rows]="rowsAn" [(first)]="firstAn" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        [rowsPerPageOptions]="[10,20,30,50,100]"
        [customSort]="true" (sortFunction)="customSort($event)">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columnsAnalytical">
              <th *ngIf="col.field != 'acao'" class="text-center" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
              <th *ngIf="col.field == 'acao'" class="text-center" [ngStyle]="{'width': col.width}">
                {{col.header}}
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-registrosAnalitico let-columns="columnsAnalytical" let-rowIndex="rowIndex">
          <tr>
            <ng-container *ngFor="let col of columnsAnalytical">
              <!-- Coluna Mensagem - truncada e clicável com ícones -->
              <td *ngIf="col.field == 'mensagem'" class="text-center clickable-cell">
                <div class="cell-content-wrapper">
                  <div class="cell-text" 
                       (click)="abrirMensagem(rowIndex)" 
                       pTooltip="Clique para ver o conteúdo completo">
                    <i class="pi pi-eye icon-action"></i>
                    <span class="truncated-text">{{ registrosAnalitico[col.field] }}</span>
                  </div>
                  <button class="btn-copy-inline" 
                          (click)="copiarParaClipboard(registrosAnalitico[col.field]); $event.stopPropagation()"
                          pTooltip="Copiar conteúdo">
                    <i class="pi pi-copy"></i>
                  </button>
                </div>
              </td>
              
              <!-- Coluna Dado Enviado -->
              <td *ngIf="col.field == 'dadoEnviado'" class="text-center clickable-cell">
                <div class="cell-content-wrapper">
                  <div class="cell-text" 
                       (click)="abrirDadoEnviado(rowIndex)" 
                       pTooltip="Clique para ver o conteúdo completo">
                    <i class="pi pi-eye icon-action"></i>
                    <span class="truncated-text">{{ registrosAnalitico[col.field] }}</span>
                  </div>
                  <button class="btn-copy-inline" 
                          (click)="copiarParaClipboard(registrosAnalitico[col.field]); $event.stopPropagation()"
                          pTooltip="Copiar conteúdo">
                    <i class="pi pi-copy"></i>
                  </button>
                </div>
              </td>
              
              <!-- Coluna Ação - reenviar -->
              <td *ngIf="col.field == 'acao'" class="text-center">
                <button *ngIf="registrosAnalitico.reenviar !== 'S' && registrosAnalitico.reenviar !== 'A'"
                  pButton type="button"
                  icon="pi pi-refresh"
                  label="Reenviar"
                  class="p-button-sm p-button-outlined p-button-info btn-reenviar"
                  [disabled]="registrosAnalitico.reenviando"
                  (click)="reenviar(registrosAnalitico)"
                  pTooltip="Solicitar reenvio ao dealer">
                </button>
                <span *ngIf="registrosAnalitico.reenviar === 'S'" class="badge-pendente">
                  Pendente
                </span>
                <span *ngIf="registrosAnalitico.reenviar === 'A'" class="badge-aguardando">
                  Aguardando reenvio
                </span>
              </td>

              <!-- Outras colunas normais -->
              <td *ngIf="col.field != 'mensagem' && col.field != 'dadoEnviado' && col.field != 'acao'" class="text-center">
                {{ registrosAnalitico[col.field] }}
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Componente de filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'businessIntelligence.tol.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  [modalWidth]="'800px'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<!-- Modal para exibir Mensagem completa -->
<p-dialog header="Mensagem Completa" 
  [(visible)]="displayMensagem" 
  [style]="{width: '700px', maxWidth: '90vw'}" 
  [modal]="true" 
  [draggable]="false" 
  [closable]="true"
  (onHide)="fecharMensagem()">
  
  <div class="modal-content-wrapper">
    <div class="content-display">
      <pre class="content-text">{{ conteudoMensagem }}</pre>
    </div>
    
    <div class="modal-footer-actions">
      <button pButton 
        type="button" 
        label="Copiar" 
        icon="pi pi-copy" 
        class="p-button-sm p-button-success" 
        (click)="copiarParaClipboard(conteudoMensagem)">
      </button>
      <button pButton 
        type="button" 
        label="Fechar" 
        icon="pi pi-times" 
        class="p-button-sm p-button-secondary" 
        (click)="fecharMensagem()">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Modal para exibir Dado Enviado completo -->
<p-dialog header="Dado Enviado Completo" 
  [(visible)]="displayDadoEnviado" 
  [style]="{width: '700px', maxWidth: '90vw'}" 
  [modal]="true" 
  [draggable]="false" 
  [closable]="true"
  (onHide)="fecharDadoEnviado()">
  
  <div class="modal-content-wrapper">
    <div class="content-display">
      <pre class="content-text">{{ conteudoDadoEnviado }}</pre>
    </div>
    
    <div class="modal-footer-actions">
      <button pButton 
        type="button" 
        label="Copiar" 
        icon="pi pi-copy" 
        class="p-button-sm p-button-success" 
        (click)="copiarParaClipboard(conteudoDadoEnviado)">
      </button>
      <button pButton 
        type="button" 
        label="Fechar" 
        icon="pi pi-times" 
        class="p-button-sm p-button-secondary" 
        (click)="fecharDadoEnviado()">
      </button>
    </div>
  </div>
</p-dialog>

<p-toast key="businessIntelligenceDetalhado" position="bottom-right"></p-toast>
